import { inject, Injectable, signal } from '@angular/core';
import type { Params } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class UIPreferencesService {
    private readonly activatedRoute = inject(ActivatedRoute);

    readonly disableAnimation = signal(this.readDisableAnimation(this.activatedRoute.snapshot.queryParams));

    constructor() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.disableAnimation.set(this.readDisableAnimation(params));
        });
    }

    private readDisableAnimation(params: Params): boolean {
        return (params['disableAnimation'] || params['disableanimation']) !== undefined;
    }
}
